/* Skn Biome festive gifts: auto-adds complimentary samples (tier 1) and a free
   full-size gift (tier 2) when the non-prescription cart total crosses each
   threshold, removes them when it drops below, and shows a progress bar in the
   cart drawer and on the cart page. Config comes from sections/sb-festive-gifts.liquid. */
(function () {
  'use strict';
  var C = window.SB_FESTIVE;
  if (!C || !C.enabled || window.__sbFestiveLoaded) return;
  window.__sbFestiveLoaded = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var role = window.Shopify && window.Shopify.theme && window.Shopify.theme.role;
  var isPreview = (role && role !== 'main') || !!(window.Shopify && window.Shopify.designMode);
  var now = Date.now();
  var active = isPreview || (now >= Date.parse(C.start) && now <= Date.parse(C.end));

  var T1 = C.tier1;
  var T2 = C.tier2;
  var EX = (C.excludeTags || []).map(function (t) { return String(t).toLowerCase(); });

  var busy = false;
  var again = false;
  var timer = null;
  var state = null;

  function ss(get, key, val) {
    try {
      if (get) return sessionStorage.getItem(key);
      sessionStorage.setItem(key, val);
    } catch (e) {}
    return null;
  }

  function fmt(paise) {
    return '₹' + Math.ceil(paise / 100).toLocaleString('en-IN');
  }

  function isGift(line) {
    return line.variant_id === T1.variantId || !!(line.properties && line.properties._sb_gift);
  }

  function tagsFor(handle) {
    var cached = ss(true, 'sbtags:' + handle);
    if (cached) {
      try { return Promise.resolve(JSON.parse(cached)); } catch (e) {}
    }
    return fetch(root + 'products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return null;
        var t = (p.tags || []).map(function (x) { return String(x).toLowerCase(); });
        ss(false, 'sbtags:' + handle, JSON.stringify(t));
        return t;
      })
      .catch(function () { return null; });
  }

  function getCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function post(path, body) {
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error(path + ' ' + r.status);
      return r.json();
    });
  }

  function summarise(cart) {
    var lines = cart.items.filter(function (l) { return !isGift(l) && !l.gift_card; });
    return Promise.all(lines.map(function (l) { return tagsFor(l.handle); })).then(function (tagLists) {
      var eligible = 0;
      var hasExcluded = false;
      lines.forEach(function (l, i) {
        var t = tagLists[i];
        var excluded = !t || t.some(function (x) { return EX.indexOf(x) !== -1; });
        if (excluded) { hasExcluded = true; return; }
        if (l.original_line_price > 0) eligible += l.original_line_price;
      });
      return { eligible: eligible, hasExcluded: hasExcluded, paidCount: lines.length };
    });
  }

  function plan(cart, s) {
    var ops = [];
    var adds = [];
    var patchFailed = ss(true, 'sb_patch_failed') === '1';
    var want1 = active && s.eligible >= T1.amount;
    var want2 = active && s.eligible >= T2.amount && !patchFailed;
    var l1 = cart.items.filter(function (l) { return l.variant_id === T1.variantId; });
    var l2 = cart.items.filter(function (l) { return l.properties && l.properties._sb_gift === T2.kind; });

    [[want1, l1, T1], [want2, l2, T2]].forEach(function (row) {
      var want = row[0], lines = row[1], tier = row[2];
      if (want) {
        if (!lines.length) {
          var props = { _sb_gift: tier.kind };
          adds.push({ id: tier.variantId, quantity: 1, properties: props });
        } else {
          if (lines[0].quantity !== 1) ops.push({ id: lines[0].key, quantity: 1 });
          lines.slice(1).forEach(function (l) { ops.push({ id: l.key, quantity: 0 }); });
        }
      } else {
        lines.forEach(function (l) { ops.push({ id: l.key, quantity: 0 }); });
      }
    });
    return { ops: ops, adds: adds };
  }

  function apply(p) {
    var chain = Promise.resolve();
    p.ops.forEach(function (op) {
      chain = chain.then(function () { return post('cart/change.js', op); });
    });
    p.adds.forEach(function (item) {
      chain = chain.then(function () {
        return post('cart/add.js', { items: [item] }).catch(function () {
          if (item.properties && item.properties._sb_gift === T2.kind) ss(false, 'sb_patch_failed', '1');
        });
      });
    });
    return chain;
  }

  function refreshTheme() {
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sb-gifts' });
      }
    } catch (e) {}
    return fetch(root + '?section_id=cart-icon-bubble')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var src = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
        var tgt = document.getElementById('cart-icon-bubble');
        if (src && tgt) tgt.innerHTML = src.innerHTML;
      })
      .catch(function () {});
  }

  function barHTML(s) {
    var patchFailed = ss(true, 'sb_patch_failed') === '1';
    var msg;
    if (s.eligible < T1.amount) {
      msg = 'Add ' + fmt(T1.amount - s.eligible) + ' more for <strong>complimentary samples</strong>.';
    } else if (s.eligible < T2.amount) {
      msg = '<strong>Samples added.</strong> Add ' + fmt(T2.amount - s.eligible) + ' more for a free full-size gift.';
    } else if (patchFailed) {
      msg = '<strong>Complimentary samples added</strong> to your order.';
    } else {
      msg = '<strong>Samples and a free full-size gift added</strong> to your order.';
    }
    var pct = Math.min(s.eligible / T2.amount, 1) * 100;
    var mid = (T1.amount / T2.amount) * 100;
    return (
      '<p class="sb-gift-bar__msg" role="status" aria-live="polite">' + msg + '</p>' +
      '<div class="sb-gift-bar__track" aria-hidden="true">' +
        '<span class="sb-gift-bar__fill" style="width:' + pct.toFixed(1) + '%"></span>' +
        '<span class="sb-gift-bar__mark' + (s.eligible >= T1.amount ? ' is-done' : '') + '" style="left:' + mid.toFixed(1) + '%"></span>' +
        '<span class="sb-gift-bar__mark' + (s.eligible >= T2.amount ? ' is-done' : '') + '" style="left:100%"></span>' +
      '</div>' +
      '<div class="sb-gift-bar__labels" aria-hidden="true">' +
        '<span style="left:' + mid.toFixed(1) + '%">' + fmt(T1.amount) + ' · samples</span>' +
        '<span style="left:100%">' + fmt(T2.amount) + ' · full-size gift</span>' +
      '</div>' +
      (s.hasExcluded ? '<p class="sb-gift-bar__note">Prescription items don’t count toward festive gifts.</p>' : '')
    );
  }

  function ensureBar(container, where) {
    var bar = container.parentNode.querySelector(':scope > .sb-gift-bar');
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'sb-gift-bar';
      container.insertAdjacentElement(where, bar);
    }
    return bar;
  }

  function placeBars() {
    if (!state) return;
    var show = active && state.paidCount > 0;
    var html = show ? barHTML(state) : '';
    var targets = [];
    var header = document.querySelector('#CartDrawer .drawer__inner > .drawer__header');
    if (header) targets.push(ensureBar(header, 'afterend'));
    var pageItems = document.querySelector('cart-items');
    if (pageItems) targets.push(ensureBar(pageItems, 'beforebegin'));
    targets.forEach(function (bar) {
      if (bar.getAttribute('data-html') !== html) {
        bar.innerHTML = html;
        bar.setAttribute('data-html', html);
      }
      bar.hidden = !show;
    });
  }

  function reconcile() {
    if (busy) { again = true; return; }
    busy = true;
    getCart()
      .then(function (cart) {
        return summarise(cart).then(function (s) {
          var p = plan(cart, s);
          if (!p.ops.length && !p.adds.length) return s;
          return apply(p).then(refreshTheme).then(function () { return s; });
        });
      })
      .then(function (s) { state = s; placeBars(); })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (again) { again = false; schedule(); }
      });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(reconcile, 250);
  }

  if (!active) {
    // Outside the festive window on the live theme: clear any leftover gifts once per session.
    if (ss(true, 'sb_cleanup') !== '1') { ss(false, 'sb_cleanup', '1'); reconcile(); }
    return;
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
      if (e && e.source === 'sb-gifts') return;
      schedule();
    });
  }

  var raf = null;
  new MutationObserver(function () {
    if (raf) return;
    raf = requestAnimationFrame(function () { raf = null; placeBars(); });
  }).observe(document.body, { childList: true, subtree: true });

  window.addEventListener('pageshow', function (e) { if (e.persisted) schedule(); });
  reconcile();
})();
